import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {AuthService, DataResourceModel, LocalisableContextData, provideSearchModel} from "@fedeltapointofsale/data-client";
import {GroupedOutletCustomSearchModel} from "../../../../localisation/grouped-outlet-custom-search.model";

/**
 * localisation component to be used in a edit.
 */
@Component({
    selector: "wbo-edit-localisation",
    templateUrl: "./edit-localisation.component.html",
    styleUrls: ["./edit-localisation.component.scss"],
    providers: [provideSearchModel(GroupedOutletCustomSearchModel)]
})
export class EditLocalisationComponent implements OnInit {

    @Input() localisable: LocalisableContextData;
    @Input() readonly: boolean;

    @Input() forceEnableRestrictions: boolean;

    @Output() selectionChanged: EventEmitter<any> = new EventEmitter();

    isUserUniversal: boolean;

    constructor(private searchModel: GroupedOutletCustomSearchModel, public dataResourceModel: DataResourceModel<any>, private authService: AuthService) {
        this.isUserUniversal = authService.isUniversal();
    }

    ngOnInit(): void {
        this.searchModel.search();
    }

    get restricted(): any {
        return !this.localisable.universal;
    }

    set restricted(restricted: any) {
        this.localisable.universal = !restricted;
    }

    outletSelectionChanged(): void {
        this.selectionChanged.emit();
        if ( this.localisable.outlets.length > 0 || this.localisable.customObjects.length > 0) {
            this.localisable.universal = false;
        }
    }
}
